export const VERIFICATION_CODE_LENGTH = 6;
const TOKEN_PATTERN = new RegExp(`^[a-zA-Z0-9]{${VERIFICATION_CODE_LENGTH}}$`);
const STORAGE_PREFIX = 'vistoria-validation-token:';

const storageKey = (chave: string) => `${STORAGE_PREFIX}${chave}`;

export const normalizeValidationToken = (value: string) =>
  value.trim().toUpperCase();

export const isValidationTokenFormatValid = (value: string) =>
  TOKEN_PATTERN.test(normalizeValidationToken(value));

export const saveValidationToken = (chave: string, token: string) => {
  sessionStorage.setItem(storageKey(chave), normalizeValidationToken(token));
};

export const getValidationToken = (chave: string) => {
  const storedValue = sessionStorage.getItem(storageKey(chave));

  if (!storedValue) return null;

  if (!isValidationTokenFormatValid(storedValue)) {
    sessionStorage.removeItem(storageKey(chave));
    return null;
  }

  return normalizeValidationToken(storedValue);
};

export const clearValidationToken = (chave: string) => {
  sessionStorage.removeItem(storageKey(chave));
};

export const getValidationTokenHeaders = (
  chave: string,
  idResource?: number,
) => {
  const token = getValidationToken(chave);
  const headers: Record<string, string> = {};

  if (token) {
    headers['x-validation-token'] = token;
  }

  if (Number.isInteger(idResource) && Number(idResource) > 0) {
    headers['x-resource-id'] = String(idResource);
  }

  return headers;
};
